import type { DemoKey } from '../types';

export const uk: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Математика · Статистика',
  'app.title': 'Статистика',
  'panel.experiment': 'Сцена',
  'panel.params': 'Параметри',

  'exp.survey-explorer.title': 'Оглядач опитування',
  'exp.survey-explorer.desc': 'Виберіть стовпець; демо обирає відповідне зведення.',
  'exp.distribution-sculptor.title': 'Скульптор розподілів',
  'exp.distribution-sculptor.desc': 'Перетягуй точки та дивись, як реагують статистики.',
  'exp.two-variable-lab.title': 'Лабораторія двох змінних',
  'exp.two-variable-lab.desc': 'Розсіювання, припасування, питання про причину.',
  'exp.sampling-lab.title': 'Лабораторія вибірки',
  'exp.sampling-lab.desc': 'Як техніка та розмір рухають середнє вибірки.',
  'exp.probability-diagrams.title': 'Діаграми ймовірності',
  'exp.probability-diagrams.desc': 'Венні та деревні погляди для складних подій.',

  'type.qualitative-nominal.label': 'Якісний · номінальний',
  'type.qualitative-nominal.def': 'Категорії без природного порядку.',
  'type.qualitative-ordinal.label': 'Якісний · порядковий',
  'type.qualitative-ordinal.def': 'Категорії з осмисленим порядком.',
  'type.qualitative-multi.label': 'Якісний · багатозначний',
  'type.qualitative-multi.def': 'Кожне спостереження може мати кілька тегів.',
  'type.quantitative-discrete.label': 'Кількісний · дискретний',
  'type.quantitative-discrete.def': 'Числа з фіксованим кроком.',
  'type.quantitative-continuous.label': 'Кількісний · неперервний',
  'type.quantitative-continuous.def': 'Числа на неперервній шкалі.',

  'column.name.label': 'Ім’я учня',
  'column.height_cm.label': 'Зріст',
  'column.shoe_size_eu.label': 'Розмір взуття (EU)',
  'column.study_hours.label': 'Год. навчання / тижд.',
  'column.test_score.label': 'Бал тесту',
  'column.sports_played.label': 'Види спорту',
  'column.eye_color.label': 'Колір очей',
  'column.commute_min.label': 'Дорога',
  'column.grade_year.label': 'Клас',
  'column.homework_effort.label': 'Старанність у дз',
  'column.ice-cream-sales.label': 'Продажі морозива',
  'column.drownings.label': 'Утоплення',
  'column.month.label': 'Місяць',
  'column.storks.label': 'Лелеки',
  'column.births.label': 'Народження',
  'column.country_area_km2.label': 'Площа країни',
  'column.sleep_hours.label': 'Години сну',
  'column.reaction_ms.label': 'Час реакції',

  'dataset.master-survey.label': 'Опитування класу',
  'dataset.master-survey.desc': '30 змодельованих учнів.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Морозиво vs утоплення',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Обидва зростають і падають із сезоном. Утоплення не спричиняють продажі.',
  'dataset.spurious-storks-vs-births.label': 'Лелеки vs народження',
  'dataset.spurious-storks-vs-births.desc':
    'У більших країнах більше лелек і більше народжень. Птахи не причина.',
  'dataset.real-sleep-vs-reaction-time.label': 'Сон vs час реакції',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Більше сну — швидша реакція. Реальна від’ємна кореляція — з правдоподібним механізмом.',

  'tag.football.label': 'Футбол',
  'tag.basketball.label': 'Баскетбол',
  'tag.volleyball.label': 'Волейбол',
  'tag.swimming.label': 'Плавання',
  'tag.none.label': 'Жоден',

  'population.gaussian.label': 'Дзвоноподібний',
  'population.right-skewed.label': 'Скошений праворуч',
  'population.bimodal.label': 'Бімодальний (зі стратами)',
  'population.uniform.label': 'Рівномірний',

  'venn.dice-even-or-prime.label': 'Куб: парне або просте',
  'venn.class-sports-2set.label': 'Спорт (2 множини)',
  'venn.class-sports-3set.label': 'Спорт (3 множини)',
  'venn.custom.label': 'Власне',

  'tree.draw-without-replacement.label': 'Без повернення',
  'tree.custom.label': 'Власне',
  'tree.coin.heads': 'О',
  'tree.coin.tails': 'Р',
  'tree.draw.start': 'Мішок: 2 червоних, 3 синіх',
  'tree.draw.red': 'Червоний',
  'tree.draw.blue': 'Синій',
  'tree.custom.start': 'Старт',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Гістограма',
  'card.cumulative': 'Кумулятивна частота',
  'card.box': 'Ящик з вусами',
  'card.summary': 'П’ять чисел',
  'card.bar': 'Стовпчикова діаграма',
  'card.mode': 'Мода',
  'card.tag-frequency': 'Частота тегів',
  'card.mode-tag': 'Найчастіший тег',
  'card.empty-no-order': 'Незастосовно',
  'card.empty-multi': 'Незастосовно',
  'card.numberline': 'Числова пряма',
  'card.scatter': 'Розсіювання',
  'card.description': 'Що відбувається',
  'card.population': 'Сукупність',
  'card.sampling-distribution': 'Середні вибірок',
  'card.venn': 'Венн',
  'card.tree': 'Дерево',
  'card.probabilities': 'Імовірності',

  'param.dataset.label': 'Набір даних',
  'param.column.label': 'Стовпець',
  'param.bins.label': 'Інтервали',
  'param.shape.label': 'Початкова форма',
  'param.show-mean.label': 'Показати середнє',
  'param.show-median.label': 'Показати медіану',
  'param.x-col.label': 'Стовпець X',
  'param.y-col.label': 'Стовпець Y',
  'param.show-regression.label': 'Лінія регресії',
  'param.show-residuals.label': 'Залишки',
  'param.show-confounder.label': 'Показати конфаундер',
  'param.population.label': 'Сукупність',
  'param.technique.label': 'Метод',
  'param.sample-size.label': 'Розмір вибірки',
  'param.stratum.label': 'Страта',
  'param.bias.label': 'Зсув',
  'param.mode.label': 'Режим',
  'param.preset.label': 'Пресет',
  'param.universe.label': 'Розмір простору',
  'param.show-prob.label': 'Показати ймовірності',
  'param.treat-as-numeric.label': 'Як числове',

  'stat.count': 'Кількість',
  'stat.mean': 'Середнє',
  'stat.median': 'Медіана',
  'stat.range': 'Розмах',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'МКР',
  'stat.outliers': 'Викиди',
  'stat.r': 'r Пірсона',
  'stat.r2': 'r²',
  'stat.slope': 'Нахил',
  'stat.intercept': 'Вільний член',
  'stat.n': 'n',
  'stat.population-mean': 'Справжнє середнє',
  'stat.latest-sample-mean': 'Середнє вибірки',
  'stat.sample-mean-spread': 'СВ середнього вибірки',
  'stat.sample-count': 'Узято вибірок',
  'outlier.upper': 'Верхні викиди',
  'outlier.lower': 'Нижні викиди',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Перевибрати',
  'btn.run-100': '100 вибірок',
  'btn.stop': 'Зупинити',
  'btn.clear-history': 'Очистити історію',

  'explainer.no-order': 'Без порядку → ні кумулятивної, ні ящика.',
  'explainer.multi-no-iqr': 'Багатозначне → квартилі / МКР не визначені.',
  'message.no-data': 'Немає даних.',
  'message.needs-quartiles': 'Для квартилів треба ≥4 точок.',
  'message.x-zero-variance': 'У X нульова дисперсія — пряму не побудувати.',
  'message.n-too-small': 'n замале.',
  'message.stratum-clamp': 'У страті менше рядків, ніж потрібно — узято всі.',
  'message.siblings-sum-to-one': 'Сума нащадків має бути 1.',
};
